import Auth from '../api/auth';

const parseErrorCode = error => Promise.reject(error);

const authHeaders = () => {
  if (!Auth.hasAuthCookie()) return {};

  try {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();

    return {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    };
  } catch {
    return {};
  }
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    Object.assign(wootApi.defaults.headers.common, authHeaders());
  }
  wootApi.interceptors.request.use(config => {
    config.headers = config.headers || {};
    Object.assign(config.headers, authHeaders());
    return config;
  });
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
